export const capitalize = (str?: string) =>
  !!str
    ? str.charAt(0).toUpperCase() + str.slice(1).toLocaleLowerCase()
    : undefined

export const isString = (value: unknown): value is string =>
  typeof value === 'string' || value instanceof String

export const padWithZero = (value: number) => value.toString().padStart(2, '0')